export default __webpack_public_path__ + "static/media/basket_ball.bc605a05.png";